'use client';

import _defineProperty from "/codebuild/output/src4231/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src4231/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["classNames", "className", "style", "styles", "unstyled", "vars", "radius", "color", "title", "children", "id", "icon", "withCloseButton", "onClose", "closeButtonLabel", "variant", "autoContrast"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx, jsxs } from 'react/jsx-runtime';
import { useId } from '@mantine/hooks';
import 'react';
import { getRadius } from '../../core/utils/get-size/get-size.mjs';
import { createVarsResolver } from '../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../core/MantineProvider/use-props/use-props.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { useStyles } from '../../core/styles-api/use-styles/use-styles.mjs';
import { Box } from '../../core/Box/Box.mjs';
import { factory } from '../../core/factory/factory.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
import '../CloseButton/CloseIcon.mjs';
import { CloseButton } from '../CloseButton/CloseButton.mjs';
import classes from './Alert.module.css.mjs';
var defaultProps = {};
var varsResolver = createVarsResolver(function (theme, _ref) {
  var radius = _ref.radius,
    color = _ref.color,
    variant = _ref.variant,
    autoContrast = _ref.autoContrast;
  var colors = theme.variantColorResolver({
    color: color || theme.primaryColor,
    theme: theme,
    variant: variant || "light",
    autoContrast: autoContrast
  });
  return {
    root: {
      "--alert-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--alert-bg": color || variant ? colors.background : void 0,
      "--alert-color": colors.color,
      "--alert-bd": color || variant ? colors.border : void 0
    }
  };
});
var Alert = factory(function (_props, ref) {
  var props = useProps("Alert", defaultProps, _props);
  var classNames = props.classNames,
    className = props.className,
    style = props.style,
    styles = props.styles,
    unstyled = props.unstyled,
    vars = props.vars,
    radius = props.radius,
    color = props.color,
    title = props.title,
    children = props.children,
    id = props.id,
    icon = props.icon,
    withCloseButton = props.withCloseButton,
    onClose = props.onClose,
    closeButtonLabel = props.closeButtonLabel,
    variant = props.variant,
    autoContrast = props.autoContrast,
    others = _objectWithoutProperties(props, _excluded);
  var getStyles = useStyles({
    name: "Alert",
    classes: classes,
    props: props,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    unstyled: unstyled,
    vars: vars,
    varsResolver: varsResolver
  });
  var rootId = useId(id);
  var titleId = title && "".concat(rootId, "-title") || void 0;
  var bodyId = "".concat(rootId, "-body");
  return /* @__PURE__ */jsx(Box, _objectSpread(_objectSpread(_objectSpread({
    id: rootId
  }, getStyles("root", {
    variant: variant
  })), {}, {
    variant: variant,
    ref: ref
  }, others), {}, {
    role: "alert",
    "aria-describedby": bodyId,
    "aria-labelledby": titleId,
    children: /* @__PURE__ */jsxs("div", _objectSpread(_objectSpread({}, getStyles("wrapper")), {}, {
      children: [icon && /* @__PURE__ */jsx("div", _objectSpread(_objectSpread({}, getStyles("icon")), {}, {
        children: icon
      })), /* @__PURE__ */jsxs("div", _objectSpread(_objectSpread({}, getStyles("body")), {}, {
        children: [title && /* @__PURE__ */jsx("div", _objectSpread(_objectSpread({}, getStyles("title")), {}, {
          "data-with-close-button": withCloseButton || void 0,
          children: /* @__PURE__ */jsx("span", _objectSpread(_objectSpread({
            id: titleId
          }, getStyles("label")), {}, {
            children: title
          }))
        })), children && /* @__PURE__ */jsx("div", _objectSpread(_objectSpread({
          id: bodyId
        }, getStyles("message")), {}, {
          "data-variant": variant,
          children: children
        }))]
      })), withCloseButton && /* @__PURE__ */jsx(CloseButton, _objectSpread(_objectSpread({}, getStyles("closeButton")), {}, {
        onClick: onClose,
        variant: "transparent",
        size: 16,
        iconSize: 16,
        "aria-label": closeButtonLabel,
        unstyled: unstyled
      }))]
    }))
  }));
});
Alert.classes = classes;
Alert.displayName = "@mantine/core/Alert";
export { Alert };